import type { Document } from "@repo/types";
import { ExportForm } from "../common/ExportForm";
import { documentsExportService } from "@/services/documentsExportService";

export interface ExportDocumentFormProps {
  getDocuments: () => Document[];
  getPreselectedFields: () => string[];
  onCancel?: () => void;
}

export const ExportDocumentForm = ({
  getDocuments,
  getPreselectedFields,
  onCancel,
}: ExportDocumentFormProps) => {
  return (
    <ExportForm<Document>
      getData={getDocuments}
      getPreselectedFields={getPreselectedFields}
      onCancel={onCancel}
      downloadName="documents.csv"
      exportService={documentsExportService}
    />
  );
};
